import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      {/* Banner Section */}
      <section className="privacy-banner">
        <div className="privacy-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">PRIVACY POLICY</h2>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="privacy-content">
        <div className="privacy-wrapper">
          <div className="privacy-text">
            <h2 className="content-title">Terms of usage of information</h2>
            
            <p>
              Thank you for visiting www.damnetworks.com/ampire/.com. This section contains the Privacy Policy ("Policy") of the Website.
            </p>

            <p>
              Ampire Finance Private Limited is a company registered in India under the Reserve Bank of India regulations and the registered address is given in the "Contact us" section of this website. The contents of this website/mobile application is owned by Ampire Finance Limited.
            </p>

            <p>
              Each visitor ("You or customer") who visits the Website, accesses any of the pages and/or provides information on the Website to Ampire Finance Limited ("Ampire " or "We" or "Our") has agreed to the terms set out in this Policy.
            </p>

            <h3 className="section-heading">Collection of Personal Information</h3>

            <p>
              Personal information we collect could be categorised as "voluntarily provided" information and "automatically collected" information and the same will be collected in accordance with applicable laws.
            </p>

            <p>
              "Voluntarily provided" information refers to any information you knowingly and actively provide us when using our websites, or applying for any of our products or services.
            </p>

            <p>
              "Automatically collected" information refers to any information automatically sent by your devices or received from your devices and about your devices in the course of you accessing our or in relation to using of any of our products and services. The term 'device' refers to any internet connected device such as a phone, tablet, computer or any other device that can be used to visit our websites.
            </p>

            <p>
              This Policy describes the collection and usage of information by Ampire Finance's("Information"), including Information collected by the Ampire Finance's server from your browser, when you visit the Website, receive emails, or phone calls, interact with advertisements we have on any third party websites. Further, by registering at the Website, you authorize Ampire Finance to contact you in order to communicate details of our services. You have consented to receive details of programmes and schemes, promotional offers running on the Website & offers offered by the associated third parties.
            </p>

            <p>
              Our website may record your visit to our website including the pages you visit, the date and time of your visit, your IP addresses, browser information, any downloads from this website, the link through which you have reached us, etc. This information may be used for internal analytical purposes. With the above information, specific users are not identified.When you visit our website, in general we do not seek any personal information from you, unless you chose to provide any details with us for any potential business transactions.
            </p>

            <p>
              We do not collect any personal information except for the purpose of business transactions as required by the law. Any information that is collected by us is secured and not shared or sold to any 3rd party, except for the business transaction purposes or as required by the authorities of the Indian Laws.
            </p>

            <p>
              We use your data to provide and improve our services. By using the service, you agree to the collection and use of information in accordance with this policy. In order to operate the Website and provide you with details on services, facilities and programmes that may be of interest to you, We may collect Information including but not limited to credit and debit card numbers, phone number, email address, postal address, computer's unique Internet Protocol address, bank and other account numbers, home town, gender, age, website cookies and website 2 usage data from you. We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device ("Usage Data").
            </p>

            <p>
              This usage data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
            </p>

            <p>
              Your personal details may also be used for automated IVR calls or manual calls during for regular business verifications activities and business development purposes. For any financial transactions made with us, or through us, a verification call will be made even if you are registered for DND (Do not disturb) option. For the same purpose a personal visit may also be made by our representatives.
            </p>

            <p>
              When you access our services by or through a mobile device, this usage data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
            </p>

            <p>
              We may receive and process information about your location. For example, with your consent, we may collect information about the specific location of your mobile device (for example, by using GPS or Bluetooth). We may also receive location information from you when you choose to share such information on our Services, including by associating your content with a location, or we may derive your approximate location from other information about you, including your IP address.
            </p>

            <h3 className="section-heading">Tracking & Cookies Data</h3>

            <p>
              We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
            </p>

            <p>
              We collects only such personal information that we believe to be relevant and would be required to understand your business's financial requirements. All information collected shall be used by us for the sole purpose of providing you with the best possible customer products and services.
            </p>

            <p>
              Ampire Finance shall not sell, rent, or otherwise distribute information provided by You to a third party unless the same is required by us to provide services to You, or to enable a transaction, credit reporting, required pursuant to any law and conditions applicable to such information as agreed to by You.
            </p>

            <p>
              We may share your contact information with its affiliates, staff or third parties with permitted access. However, all such affiliates, staff or third parties, who receive your information, shall be required to observe our confidentiality obligations.
            </p>

            <p>
              We may use third-party service providers to monitor and analyse the use of our services. We may engage third-party advertising companies or advertising agencies to advertise on the Website. These companies may utilise information (excepting personal information) about your visits to the Websites and other websites in order to provide advertisements on the website and other sites about services, facilities and programmes that may be of interest to you.
            </p>

            <p>
              The Website may contain links to third party websites that are not owned or controlled by Ampire Finance. This Policy does not address how information is handled when provided to any third parties nor the policy of any other affiliate or third-party website that may be linked to from the Website.
            </p>

            <p>
              Following are the legal Requirements for the disclosure of data:
            </p>

            <h3 className="section-heading">Transfer of Data</h3>

            <p>
              Your information, including Personal Data, may be transferred to servers and maintained on computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction. If you are located outside India and choose to provide information to us, please note that we transfer the data, including Personal Data, to India and process it here. Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
            </p>

            <h3 className="section-heading">Restricted Access</h3>

            <p>
              Access for our personnel to personal information collected from you will only be on a need-to-know basis that is relevant for their respective function. Where it will suffice, access will be provided to depersonalized/anonymized/pseudonymized information as appropriate.
            </p>

            <h3 className="section-heading">Policy guidelines on storage of personal information</h3>

            <p>
              There are clear policy guidelines regarding the storage of customer data including the type of data that can be stored, the length of time for which data can be stored, restrictions on the use of data, data destruction protocol, standards for handling security breach, etc., Such guidelines will also be updated from time to time and always displayed prominently on our websites.
            </p>

            <h3 className="section-heading">Disclosure of Data</h3>

            <h4 className="subsection-heading">Legal Requirements</h4>

            <p>
              Ampire Finance may disclose your Personal Data in the good faith belief that such action is necessary to:
            </p>

            <ul className="policy-list">
              <li>To comply with a legal obligation</li>
              <li>To protect and defend the rights or property of Ampire Finance</li>
              <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
              <li>To protect the personal safety of users of the Service or the public</li>
              <li>To protect against legal liability</li>
            </ul>

            <h3 className="section-heading">Changes To This Privacy Policy</h3>

            <p>
              From time to time, we may change this Privacy Policy. The effective date of this Policy, as stated below, indicates the last time this policy was revised or materially changed. Checking the effective date below allows you to determine whether there have been changes since the last time you reviewed the Policy.
            </p>

            <p>
              You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
            </p>

            <h3 className="section-heading">Copyrights</h3>

            <p>
              You may not reproduce the contents of this website without an express consent from the Ampire Finance Limited. However sharing of information and links for the purpose of Business Development with Ampire Finance is permitted without approval from us.
            </p>

            <h3 className="section-heading">Complaints, Comments / Feedback</h3>

            <p>
              For any complains or information on the privacy policy or if you feel any of the policy principals are not followed, you may reach out to us on the contact information given on this website.
            </p>

            <p>
              Alternatively, you can write a mail to: <a href="mailto:support@ampirefinance.com" className="email-link">support@ampirefinance.com</a>
            </p>

            <div className="effective-date">
              <p><strong>Effective date of Policy: 15th Oct 2024.</strong></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;

